export default __webpack_public_path__ + "static/media/trash.24f013c9.svg";